import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { LoadingScreen } from 'src/components/loading-screen';

const FileViewerPlayground = lazy(() => import('src/pages/playground/file-viewer'));

export const playgroundRoutes: RouteObject[] = [
  {
    path: '/playground',
    children: [
      {
        path: 'file-viewer',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <FileViewerPlayground />
          </Suspense>
        ),
      },
    ],
  },
];
